import type { ModuleVersionRecord } from "@contracts";
import {
  IconAdjustmentsHorizontal,
  IconCalendar,
  IconChartBar,
  IconClock,
  IconCode,
  IconCpu,
  IconDatabase,
  IconDroplet,
  IconGauge,
  IconLibraryPhoto,
  IconLine,
  IconPhoto,
  IconServer2,
  IconSun,
  IconTemperature,
  IconTextSize,
  IconWind,
} from "@tabler/icons-react";
import type { ComponentType } from "react";

export const moduleIcons: Record<string, ComponentType<{ size?: number; stroke?: number; className?: string }>> = {
  clock: IconClock,
  "weather-illustration": IconSun,
  "weather-summary": IconTemperature,
  "weather-details": IconDroplet,
  "server-status": IconServer2,
  "codex-quota": IconCode,
  divider: IconLine,
  text: IconTextSize,
  image: IconPhoto,
};

export function ModuleIcon({ module, size = 22, className }: { module: ModuleVersionRecord | undefined; size?: number; className?: string }) {
  const Icon = moduleIcons[module?.manifest.entry ?? ""] ?? IconAdjustmentsHorizontal;
  return <Icon size={size} stroke={1.8} className={className} />;
}

export function categoryLabel(category: string): string {
  return ({ time: "时间与日期", weather: "天气", system: "服务器与设备", quota: "额度与服务", basic: "基础组件" } as Record<string, string>)[category] ?? category;
}

export function moduleSample(module: ModuleVersionRecord): string {
  const fixture = module.manifest.fixtures.normal ?? {};
  if (module.manifest.entry === "clock") return "当前时间与日期";
  if (module.manifest.entry === "weather-illustration") return String(fixture.condition ?? "天气插画集合");
  if (module.manifest.entry === "weather-summary") return `${fixture.location ?? "地点"} · ${fixture.temperature ?? "--"}°C`;
  if (module.manifest.entry === "weather-details") return `湿度 ${fixture.humidity ?? "--"}% · 风速 ${fixture.windSpeed ?? "--"}`;
  if (module.manifest.entry === "server-status") return "5 项系统指标";
  if (module.manifest.entry === "codex-quota") return `剩余额度 ${fixture.remainingPercent ?? "--"}%`;
  if (module.manifest.entry === "divider") return "实线 / 虚线 / 点线";
  if (module.manifest.entry === "text") return "自由文本";
  if (module.manifest.entry === "image") return "媒体资产";
  return module.version;
}

export const metricIcons = { cpu: IconCpu, memory: IconChartBar, disk: IconDatabase, load: IconGauge, time: IconCalendar, wind: IconWind, assets: IconLibraryPhoto };

export function formatRelative(value: string | null): string {
  if (!value) return "尚未生成";
  const seconds = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 1_000));
  if (seconds < 60) return `${seconds} 秒前`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} 分钟前`;
  return `${Math.floor(minutes / 60)} 小时前`;
}
